'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _httpmanager = require('@its/httpmanager');

var _Loading = require('../../Pages/Loading/Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _Forbidden = require('../../Pages/Forbidden/Forbidden');

var _Forbidden2 = _interopRequireDefault(_Forbidden);

var _Error = require('../../Pages/Error/Error');

var _Error2 = _interopRequireDefault(_Error);

var _Request = require('../../../Request');

var _Request2 = _interopRequireDefault(_Request);

var _authUtils = require('../authUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var onSuccess = function onSuccess(result) {
  (0, _authUtils.login)({
    token: result.body.access_token,
    userName: result.body.userName,
    refreshToken: result.body.refresh_token
  });
  window.location = '/';
};

var onError = function onError() {
  (0, _authUtils.logout)();
  return _react2.default.createElement(_Error2.default, null);
};

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.state = _react2.default.createElement(_Loading2.default, null);
    return _this;
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var params = (0, _httpmanager.getQueryStrings)(['external_access_token', 'haslocaluser', 'provider', 'external_email', 'external_user_name']);

      if (params.haslocaluser === 'False') {
        (0, _authUtils.logout)();
        if (process.env.auth.canRegister) {
          // TODO : associate
        } else {
          this.setState(_react2.default.createElement(_Forbidden2.default, null));
        }
      } else {
        var request = _httpmanager.doGetRequest.bind(null, {
          url: 'auth/ObtainLocalAccessToken',
          query: {
            provider: params.provider,
            externalAccessToken: params.external_access_token
          }
        });
        this.setState(_react2.default.createElement(_Request2.default, { request: request, onSuccess: onSuccess, onError: onError }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state;
    }
  }]);

  return _class;
}(_react2.default.Component);

exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Auth/AuthComplete/AuthComplete.js
 ** module id = 482
 ** module chunks = 0
 **/